var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import BN from 'bignumber.js';
import { ethers } from 'ethers';
import { Interface } from 'ethers/lib/utils';
import { Config } from '../../../../Fct/Config';
import { AaveV3 } from '../../../../Fct/pluginsExport';
import { AaveV2 } from '../AaveV2';
import { GetAssetsPrices } from '../getters/getAssetsPrices';
import { normalize, valueToZDBigNumber } from './bignumber';
import { getAssetRateByApy } from './getAssetRateByApy';
import { RAY_DECIMALS, rayPow } from './rayMath';
var RAY = new BN(Math.pow(10, 27));
var SECONDS_PER_YEAR = 31536000;
var AaveHelper = /** @class */ (function (_super) {
    __extends(AaveHelper, _super);
    function AaveHelper() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.RAY = RAY;
        _this.SECONDS_PER_YEAR = SECONDS_PER_YEAR;
        _this.createContract = function (_a) {
            var address = _a.address, contractInterface = _a.contractInterface, returns = _a.returns;
            var contract = new ethers.Contract(address, new Interface(["function ".concat(contractInterface, " view ").concat(returns)]), _this.library);
            return contract;
        };
        _this.getAssetPrice = function (_a) {
            var asset = _a.asset, usdPriceEth = _a.usdPriceEth;
            return __awaiter(_this, void 0, void 0, function () {
                var getAssetPrice, contract, call, values, data, priceInEth, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            getAssetPrice = new AaveV2.getters.GetAssetPrice({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: getAssetPrice.input.params.to.value,
                                contractInterface: getAssetPrice.contractInterface,
                                returns: getAssetPrice.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, getAssetPrice.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getAssetPrice.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data)
                                return [2 /*return*/, undefined];
                            priceInEth = normalize(data.toString(), 18);
                            return [2 /*return*/, {
                                    wei: data.toString(),
                                    eth: priceInEth,
                                    usd: usdPriceEth ? new BN(priceInEth).multipliedBy(usdPriceEth).toFixed(2) : undefined,
                                }];
                        case 4:
                            e_1 = _b.sent();
                            console.error(e_1);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAssetsPrices = function (_a) {
            var usdPriceEth = _a.usdPriceEth, assets = _a.assets;
            return __awaiter(_this, void 0, void 0, function () {
                var getAssetsPrices, assetsParams, filtredAssets, assetsAddresses, contract, call, values, data_1, e_2;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            getAssetsPrices = new GetAssetsPrices({
                                chainId: String(this.chainId),
                            });
                            assetsParams = getAssetsPrices.input.methodParams.assets;
                            filtredAssets = assets
                                ? (_b = assetsParams.options) === null || _b === void 0 ? void 0 : _b.filter(function (a) {
                                    var value = a.value.toLocaleLowerCase();
                                    return assets.map(function (asset) { return asset.toLocaleLowerCase(); }).includes(value);
                                })
                                : assetsParams.options;
                            if (!(filtredAssets === null || filtredAssets === void 0 ? void 0 : filtredAssets.length)) {
                                console.error("assets ".concat(assets, " not found"));
                                return [2 /*return*/, []];
                            }
                            assetsAddresses = filtredAssets.map(function (asset) { return asset.value; });
                            assetsParams.set({
                                value: assetsAddresses,
                            });
                            contract = this.createContract({
                                address: getAssetsPrices.input.params.to.value,
                                contractInterface: getAssetsPrices.contractInterface,
                                returns: getAssetsPrices.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, getAssetsPrices.create()];
                        case 1:
                            call = _c.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _c.label = 2;
                        case 2:
                            _c.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getAssetsPrices.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data_1 = (_c.sent());
                            if (!data_1)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, filtredAssets === null || filtredAssets === void 0 ? void 0 : filtredAssets.map(function (asset, i) {
                                    var priceInEth = normalize(data_1[i].toString(), 18);
                                    return __assign({ wei: data_1[i].toString(), eth: priceInEth, usd: usdPriceEth ? new BN(priceInEth).multipliedBy(usdPriceEth).toFixed(2) : undefined }, asset);
                                })];
                        case 4:
                            e_2 = _c.sent();
                            console.error(e_2);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAssetAvailableBorrowPower = function (_a) {
            var asset = _a.asset, account = _a.account, usdPriceEth = _a.usdPriceEth;
            return __awaiter(_this, void 0, void 0, function () {
                var userAccountData, availableBorrowsETH, availableBorrowEth, assetEthPrice, availableBorrowEthETH, assetBorrowPower, assetBorrowPowerUsd;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getUserAccountData({ account: account })];
                        case 1:
                            userAccountData = _b.sent();
                            if (!userAccountData) {
                                return [2 /*return*/];
                            }
                            availableBorrowsETH = userAccountData.availableBorrowsETH;
                            availableBorrowEth = new BN(availableBorrowsETH);
                            return [4 /*yield*/, this.getAssetPrice({ asset: asset, usdPriceEth: usdPriceEth })];
                        case 2:
                            assetEthPrice = _b.sent();
                            if (!assetEthPrice) {
                                return [2 /*return*/];
                            }
                            availableBorrowEthETH = normalize(availableBorrowEth, 18);
                            assetBorrowPower = new BN(availableBorrowEthETH).dividedBy(assetEthPrice.eth).multipliedBy(0.99);
                            assetBorrowPowerUsd = assetEthPrice.usd
                                ? assetBorrowPower.multipliedBy(assetEthPrice.usd).toFixed(2)
                                : undefined;
                            return [2 /*return*/, { eth: assetBorrowPower.toString(), usd: assetBorrowPowerUsd }];
                    }
                });
            });
        };
        _this.getReserveTokensAddresses = function (_a) {
            var asset = _a.asset;
            return __awaiter(_this, void 0, void 0, function () {
                var reserveTokensAddresses, contract, data, e_3;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            reserveTokensAddresses = new AaveV2.getters.GetReserveTokensAddresses({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: reserveTokensAddresses.input.params.to.value,
                                contractInterface: reserveTokensAddresses.contractInterface,
                                returns: reserveTokensAddresses.contractInterfaceReturns,
                            });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, contract.getReserveTokensAddresses(asset, { from: this.account })];
                        case 2:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    aTokenAddress: data[0],
                                    stableDebtTokenAddress: data[1],
                                    variableDebtTokenAddress: data[2],
                                }];
                        case 3:
                            e_3 = _b.sent();
                            console.error(e_3);
                            return [2 /*return*/, undefined];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getReserveTokensAddressesV3 = function (_a) {
            var asset = _a.asset;
            return __awaiter(_this, void 0, void 0, function () {
                var reserveTokensAddresses, contract, data, e_4;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            reserveTokensAddresses = new AaveV3.getters.GetReserveData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: reserveTokensAddresses.input.params.to.value,
                                contractInterface: reserveTokensAddresses.contractInterface,
                                returns: reserveTokensAddresses.contractInterfaceReturns,
                            });
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, contract.getReserveData(asset, { from: this.account })];
                        case 2:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    aTokenAddress: data[8],
                                    stableDebtTokenAddress: data[9],
                                    variableDebtTokenAddress: data[10],
                                    underlyingAssetAddress: asset,
                                }];
                        case 3:
                            e_4 = _b.sent();
                            console.error(e_4);
                            return [2 /*return*/, undefined];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getUserAssetBalance = function (_a) {
            var asset = _a.asset, account = _a.account, usdPriceEth = _a.usdPriceEth;
            return __awaiter(_this, void 0, void 0, function () {
                var balances;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, this.getUserAssetsBalances({ account: account, usdPriceEth: usdPriceEth, options: { assets: [asset] } })];
                        case 1:
                            balances = _b.sent();
                            if (!balances)
                                return [2 /*return*/];
                            return [2 /*return*/, balances[0]];
                    }
                });
            });
        };
        _this.getUserAssetsBalances = function (_a) {
            var account = _a.account, usdPriceEth = _a.usdPriceEth, _b = _a.options, options = _b === void 0 ? {} : _b;
            return __awaiter(_this, void 0, void 0, function () {
                var assets, sortBy, prices, balances;
                var _this = this;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            assets = options.assets;
                            sortBy = options.sortBy ? options.sortBy : 'wallet';
                            return [4 /*yield*/, this.getAssetsPrices({ usdPriceEth: usdPriceEth, assets: assets })];
                        case 1:
                            prices = _c.sent();
                            if (!prices) {
                                return [2 /*return*/];
                            }
                            return [4 /*yield*/, Promise.all(prices.map(function (price) { return __awaiter(_this, void 0, void 0, function () {
                                    var value, usd, symbol, decimals, logoURI, name, asset, address, userReserveData, currentATokenBalance, currentStableDebt, currentVariableDebt, currentSupplyEth, currentStableDebtEth, currentVariableDebtEth, erc20Contract, walletBallanceWei, walletBallanceEth, walletBalanceEthUsd, currentSupplyEthUsd, currentStableDebtUsd, currentVariableDebtUsd, apy;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                value = price.value, usd = price.usd, symbol = price.symbol, decimals = price.decimals, logoURI = price.logoURI, name = price.name;
                                                asset = value;
                                                address = value;
                                                return [4 /*yield*/, this.getUserReserveData({ account: account, asset: asset })];
                                            case 1:
                                                userReserveData = _a.sent();
                                                if (!userReserveData) {
                                                    return [2 /*return*/];
                                                }
                                                currentATokenBalance = userReserveData.currentATokenBalance, currentStableDebt = userReserveData.currentStableDebt, currentVariableDebt = userReserveData.currentVariableDebt;
                                                currentSupplyEth = normalize(currentATokenBalance, 18);
                                                currentStableDebtEth = normalize(currentStableDebt, 18);
                                                currentVariableDebtEth = normalize(currentVariableDebt, 18);
                                                erc20Contract = new ethers.Contract(asset, ['function balanceOf(address _owner) view returns (uint256 balance)'], this.library);
                                                return [4 /*yield*/, erc20Contract.balanceOf(account)];
                                            case 2:
                                                walletBallanceWei = (_a.sent()).toString();
                                                walletBallanceEth = normalize(walletBallanceWei, decimals || 18);
                                                walletBalanceEthUsd = usd ? new BN(walletBallanceEth).multipliedBy(usd).toFixed(2) : undefined;
                                                currentSupplyEthUsd = usd ? new BN(currentSupplyEth).multipliedBy(usd).toFixed(2) : undefined;
                                                currentStableDebtUsd = usd ? new BN(currentStableDebtEth).multipliedBy(usd).toFixed(2) : undefined;
                                                currentVariableDebtUsd = usd ? new BN(currentVariableDebtEth).multipliedBy(usd).toFixed(2) : undefined;
                                                return [4 /*yield*/, this.getAssetAPY({ asset: asset })];
                                            case 3:
                                                apy = _a.sent();
                                                return [2 /*return*/, {
                                                        wallet: { eth: walletBallanceEth, usd: walletBalanceEthUsd, apy: apy === null || apy === void 0 ? void 0 : apy.supplyAPY },
                                                        supplied: { eth: currentSupplyEth, usd: currentSupplyEthUsd, apy: apy === null || apy === void 0 ? void 0 : apy.supplyAPY },
                                                        stableDebt: { eth: currentStableDebtEth, usd: currentStableDebtUsd, apy: apy === null || apy === void 0 ? void 0 : apy.stableBorrowAPY },
                                                        variableDebt: { eth: currentVariableDebtEth, usd: currentVariableDebtUsd, apy: apy === null || apy === void 0 ? void 0 : apy.variableBorrowAPY },
                                                        address: address,
                                                        symbol: symbol,
                                                        name: name,
                                                        decimals: decimals,
                                                        logoURI: logoURI,
                                                    }];
                                        }
                                    });
                                }); }))];
                        case 2:
                            balances = _c.sent();
                            return [2 /*return*/, balances.sort(function (price1, price2) {
                                    if (!price1)
                                        return 1;
                                    if (!price2)
                                        return -1;
                                    return new BN(price1[sortBy].usd || price1[sortBy].eth || '0').gte(price2[sortBy].usd || price2[sortBy].eth || '0')
                                        ? -1
                                        : 1;
                                })];
                    }
                });
            });
        };
        _this.getUserReserveData = function (_a) {
            var asset = _a.asset, account = _a.account;
            return __awaiter(_this, void 0, void 0, function () {
                var userReserveData, contract, call, values, data, e_5;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            userReserveData = new AaveV2.getters.GetUserReserveData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                        user: account,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: userReserveData.input.params.to.value,
                                contractInterface: userReserveData.contractInterface,
                                returns: userReserveData.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, userReserveData.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getUserReserveData.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    currentATokenBalance: data[0].toString(),
                                    currentStableDebt: data[1].toString(),
                                    currentVariableDebt: data[2].toString(),
                                    principalStableDebt: data[3].toString(),
                                    scaledVariableDebt: data[4].toString(),
                                    stableBorrowRate: data[5].toString(),
                                    liquidityRate: data[6].toString(),
                                    stableRateLastUpdated: data[7],
                                    usageAsCollateralEnabled: data[8],
                                }];
                        case 4:
                            e_5 = _b.sent();
                            console.error(e_5);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getUserAccountData = function (_a) {
            var account = _a.account;
            return __awaiter(_this, void 0, void 0, function () {
                var userAccountData, contract, call, values, data, e_6;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            userAccountData = new AaveV2.getters.GetUserAccountData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        user: account,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: userAccountData.input.params.to.value,
                                contractInterface: userAccountData.contractInterface,
                                returns: userAccountData.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, userAccountData.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getUserAccountData.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    totalCollateralETH: data[0].toString(),
                                    totalDebtETH: data[1].toString(),
                                    availableBorrowsETH: data[2].toString(),
                                    currentLiquidationThreshold: data[3].toString(),
                                    ltv: data[4].toString(),
                                    healthFactor: data[5].toString(),
                                }];
                        case 4:
                            e_6 = _b.sent();
                            console.error(e_6);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getReserveData = function (_a) {
            var asset = _a.asset;
            return __awaiter(_this, void 0, void 0, function () {
                var userReserveData, contract, call, values, data, e_7;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            userReserveData = new AaveV2.getters.GetReserveData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: userReserveData.input.params.to.value,
                                contractInterface: userReserveData.contractInterface,
                                returns: userReserveData.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, userReserveData.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getReserveData.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    configuratio: data[0].toString(),
                                    liquidityIndex: data[1].toString(),
                                    variableBorrowIndex: data[2].toString(),
                                    currentLiquidityRate: data[3].toString(),
                                    currentVariableBorrowRate: data[4].toString(),
                                    currentStableBorrowRate: data[5].toString(),
                                    lastUpdateTimestamp: data[6].toString(),
                                    aTokenAddress: data[7],
                                    stableDebtTokenAddress: data[9],
                                    variableDebtTokenAddress: data[10],
                                    interestRateStrategyAddress: data[11],
                                    id: data[12],
                                }];
                        case 4:
                            e_7 = _b.sent();
                            console.error(e_7);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAssetReserveData = function (_a) {
            var asset = _a.asset;
            return __awaiter(_this, void 0, void 0, function () {
                var reserveDataProvider, contract, call, values, data, e_8;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            reserveDataProvider = new AaveV2.getters.GetAssetReserveData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: reserveDataProvider.input.params.to.value,
                                contractInterface: reserveDataProvider.contractInterface,
                                returns: reserveDataProvider.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, reserveDataProvider.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getReserveData.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    availableLiquidity: data[0].toString(),
                                    totalStableDebt: data[1].toString(),
                                    totalVariableDebt: data[2].toString(),
                                    supplyRate: data[3].toString(),
                                    variableBorrowRate: data[4].toString(),
                                    stableBorrowRate: data[5].toString(),
                                    averageStableBorrowRate: data[6].toString(),
                                    liquidityIndex: data[6].toString(),
                                    variableBorrowIndex: data[8].toString(),
                                    lastUpdateTimestamp: data[9].toString(),
                                }];
                        case 4:
                            e_8 = _b.sent();
                            console.error(e_8);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAssetReserveDataV3 = function (_a) {
            var asset = _a.asset;
            return __awaiter(_this, void 0, void 0, function () {
                var reserveDataProvider, contract, call, values, data, e_9;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            reserveDataProvider = new AaveV3.getters.GetReserveData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: reserveDataProvider.input.params.to.value,
                                contractInterface: reserveDataProvider.contractInterface,
                                returns: reserveDataProvider.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, reserveDataProvider.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getReserveData.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    availableLiquidity: data[0].toString(),
                                    totalStableDebt: data[1].toString(),
                                    totalVariableDebt: data[2].toString(),
                                    supplyRate: data[3].toString(),
                                    variableBorrowRate: data[4].toString(),
                                    stableBorrowRate: data[5].toString(),
                                    averageStableBorrowRate: data[6].toString(),
                                    liquidityIndex: data[6].toString(),
                                    variableBorrowIndex: data[8].toString(),
                                    lastUpdateTimestamp: data[9].toString(),
                                }];
                        case 4:
                            e_9 = _b.sent();
                            console.error(e_9);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getReserveConfigurationData = function (_a) {
            var asset = _a.asset;
            return __awaiter(_this, void 0, void 0, function () {
                var reserveConfigurationData, contract, call, values, data, e_10;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            reserveConfigurationData = new AaveV2.getters.GetReserveConfigurationData({
                                chainId: String(this.chainId),
                                initParams: {
                                    methodParams: {
                                        asset: asset,
                                    },
                                },
                            });
                            contract = this.createContract({
                                address: reserveConfigurationData.input.params.to.value,
                                contractInterface: reserveConfigurationData.contractInterface,
                                returns: reserveConfigurationData.contractInterfaceReturns,
                            });
                            return [4 /*yield*/, reserveConfigurationData.create()];
                        case 1:
                            call = _b.sent();
                            values = call === null || call === void 0 ? void 0 : call.params.map(function (param) { return param.value; });
                            _b.label = 2;
                        case 2:
                            _b.trys.push([2, 4, , 5]);
                            return [4 /*yield*/, contract.getReserveConfigurationData.apply(contract, __spreadArray(__spreadArray([], __read(values), false), [{ from: this.account }], false))];
                        case 3:
                            data = (_b.sent());
                            if (!data || typeof data !== 'object' || !data.length)
                                return [2 /*return*/, undefined];
                            return [2 /*return*/, {
                                    decimals: data[0].toString(),
                                    ltv: data[1].toString(),
                                    liquidationThreshold: data[2].toString(),
                                    liquidationBonus: data[3].toString(),
                                    reserveFactor: data[4].toString(),
                                    usageAsCollateralEnabled: data[5],
                                    borrowingEnabled: data[6],
                                    stableBorrowRateEnabled: data[7],
                                    isActive: data[8],
                                    isFrozen: data[9],
                                }];
                        case 4:
                            e_10 = _b.sent();
                            console.error(e_10);
                            return [2 /*return*/, undefined];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        _this.getAssetAPY = function (_a) {
            var asset = _a.asset, version = _a.version;
            return __awaiter(_this, void 0, void 0, function () {
                var RAY, SECONDS_PER_YEAR, reserveData, _b, supplyRate, variableBorrowRate, stableBorrowRate, supplyAPY, variableBorrowAPY, stableBorrowAPY;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            RAY = this.RAY;
                            SECONDS_PER_YEAR = this.SECONDS_PER_YEAR;
                            if (!(version === 'V3')) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.getAssetReserveDataV3({ asset: asset })];
                        case 1:
                            _b = _c.sent();
                            return [3 /*break*/, 4];
                        case 2: return [4 /*yield*/, this.getAssetReserveData({ asset: asset })];
                        case 3:
                            _b = _c.sent();
                            _c.label = 4;
                        case 4:
                            reserveData = _b;
                            if (!reserveData)
                                return [2 /*return*/, undefined];
                            supplyRate = reserveData.supplyRate, variableBorrowRate = reserveData.variableBorrowRate, stableBorrowRate = reserveData.stableBorrowRate;
                            supplyAPY = rayPow(valueToZDBigNumber(new BN(supplyRate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
                            variableBorrowAPY = rayPow(valueToZDBigNumber(new BN(variableBorrowRate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
                            stableBorrowAPY = rayPow(valueToZDBigNumber(new BN(stableBorrowRate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
                            return [2 /*return*/, {
                                    supplyAPY: normalize(supplyAPY.multipliedBy(100), RAY_DECIMALS),
                                    stableBorrowAPY: normalize(stableBorrowAPY.multipliedBy(100), RAY_DECIMALS),
                                    variableBorrowAPY: normalize(variableBorrowAPY.multipliedBy(100), RAY_DECIMALS),
                                    asset: asset,
                                }];
                    }
                });
            });
        };
        _this.getAssetRateByApy = getAssetRateByApy;
        _this.getAssetAPYByRate = function (_a) {
            var rate = _a.rate;
            var RAY = _this.RAY;
            var SECONDS_PER_YEAR = _this.SECONDS_PER_YEAR;
            var apy = rayPow(valueToZDBigNumber(new BN(rate)).dividedBy(SECONDS_PER_YEAR).plus(RAY), SECONDS_PER_YEAR).minus(RAY);
            return {
                apy: normalize(apy.multipliedBy(100), RAY_DECIMALS),
            };
        };
        return _this;
    }
    return AaveHelper;
}(Config));
export { AaveHelper };
